import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	createContainer,
	createSubscriber,
	defaultRegistry,
} from '@atlassian/react-sweet-state';
import { fireModalTriggeredAnalytics, fireAddTeammatetoJiraAnalytics } from './analytics/index.tsx';
import type { State, Actions, ContainerProps, ContextConfig } from './types.tsx';

const CONTROLLER_NAME = 'invite-people-modal';

const initialState: State = {
	isOpen: false,
	inviteFlow: 'unknown',
	continueUrl: undefined,
};

const Store = createStore<State, Actions>({
	name: CONTROLLER_NAME,
	initialState,
	actions: {
		openModal:
			(
				createAnalyticsEvent: CreateUIAnalyticsEvent | null,
				{ inviteFlow, analyticsSource, continueUrl }: ContextConfig,
			) =>
			({ setState }) => {
				fireAddTeammatetoJiraAnalytics(createAnalyticsEvent, analyticsSource);

				fireModalTriggeredAnalytics(createAnalyticsEvent, inviteFlow, analyticsSource);

				setState({
					isOpen: true,
					inviteFlow,
					continueUrl,
				});
			},
		closeModal:
			() =>
			({ setState }) =>
				setState(initialState),
	},
});

export const useInvitePeopleModal = createHook(Store);
export const InvitePeopleModalProvider = createContainer<State, Actions, ContainerProps>(Store, {
	onInit:
		() =>
		({ setState }, { isOpen }) => {
			setState({ isOpen });
		},
});

export const InvitePeopleModalSubscriber = createSubscriber<
	State,
	Actions,
	boolean,
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	Record<any, any>
>(Store, {
	displayName: 'InvitePeopleModalSubscriber',
	selector: (state: State) => state.isOpen,
});

export const triggerOpenModal = (
	createAnalyticsEvent: CreateUIAnalyticsEvent | null,
	contextConfig: ContextConfig,
) => {
	defaultRegistry.getStore(Store)?.actions.openModal(createAnalyticsEvent, contextConfig);
};
